import { css } from "../../../../../styled-system/css";

export const styles = {
  icon: () =>
    css({
      alignSelf: "flex-start",
      width: "baseUnit.mobile3",
      height: "baseUnit.mobile3",
      marginRight: "baseUnit.mobile2",
      "& svg": {
        fill: "darkGreen",
      },
    }),
  itemWrapper: () =>
    css({
      alignSelf: "flex-start",
    }),
  tagName: () =>
    css({
      borderRadius: "2px",
      backgroundColor: "darkGreen",
      color: "white",
      fontSize: "body.mouse",
      letterSpacing: "body.mouse",
      lineHeight: "body.mouse",
      padding: "0 4px",
      fontWeight: 700,
      marginTop: "3px",
      marginRight: 0,
      marginBottom: 0,
      marginLeft: "baseUnit.mobile1",
    }),
  element: () =>
    css({
      display: "flex",
      alignItems: "flex-start",
      listStyle: "none",
      marginBottom: "baseUnit.mobile1",
    }),
  featureLink: () =>
    css({
      alignSelf: "flex-start",
      flexShrink: "initial",
      "& span": {
        color: "inherit",
      },
    }),
};
